<template>
  <div class="product-list">
    <Toolbar :handle-add="() => addHandlerSpecial()" v-if="userHasAccess('ticket_edit')"/>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-ticket</v-icon>{{$t('ticket.tickets')}}</h1>
        </v-flex>
        <v-flex lg12>

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
            @click:row="showHandlerSub"
@contextmenu:row="showHandlerSubExt"
          >
          <template slot="item.id" slot-scope="{ item }">
            <span v-if="item.priority.intensity >= 300 ">
              <v-chip
                 class="ma-2"
                 color="error"
                 text-color="white"
               >
                 {{ item['id'] }}
               </v-chip>
            </span>
            <span v-else >
              <v-chip
                 class="ma-2"
               >
                 {{ item['id'] }}
               </v-chip>
            </span>
          </template>
          <template slot="item.created" slot-scope="{ item }">
            {{ formatDateTime(item['created'], 'long') }}
          </template>
          <template slot="item.tags" slot-scope="{ item }">
            <div id="tags">
            <v-chip v-for="tag in item['tags']" :key="tag.id"
              class="ma-1 font-weight-bold"

              color="secondary"
            >
              {{ tag.name }}
            </v-chip>
          </div>
          </template>
          <template slot="item.status" slot-scope="{ item }">
            <v-chip
              class="ma-1 font-weight-bold"
              label
              :color="statuscolor(item['status'])"
            >
              <v-icon left v-if="item['status'].init">
                mdi-new-box
              </v-icon>
              <v-icon left v-if="item['status'].finish">
                mdi-flag-checkered
              </v-icon>
              <v-icon left v-if="! item['status'].finish && ! item['status'].init">
                mdi-cached
              </v-icon>
              <span v-if="language == 'fr'">{{ item['status'].namefr }}</span>
              <span v-else>{{ item['status'].name }}</span>
            </v-chip>
          </template>
            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandlerSub(item,'Product',props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import i18n from '../../i18n.js';
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar.vue';

export default {
  name: 'TicketListCustomer',
  servicePrefix: 'Ticket',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar
  },
  props: {
    customerParent: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      headers: [
        { text: this.$t('ticket.number'), value: 'id' },
        { text: this.$t('ticket.ticketstatus'), value: 'status' },
        { text: this.$t('global.date'), value: 'created' },
        { text: this.$t('global.title'), value: 'name' },
        { text: this.$t('ticket.bugtype'), value: 'bugType.name' },
      ],
      filters: {
        'customer' : this.customerParent['@id'],
      },
      selected: [],
      options: {sortBy : ['status.finish','created'], sortDesc : [false,true]}
    };
  },
  computed: {
    ...mapGetters('ticket', {
      items: 'list'
    }),
    ...mapFields('ticket', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
    language() {
      return i18n.locale;
    },
    parentTicket(){
      if(this.customerParent) return this.customerParent;
      return null;
    },
    parentRouteTicket(){
      if(this.customerParent) return 'TicketCreateByClient';
      return null;
    }
  },
  methods: {
    ...mapActions('ticket', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
    statuscolor(status) {
      if (status.important) {
        return 'error';
      }
      if (status.init) {
        return 'primary';
      }
      if (status.finish) {
        return 'success';
      }
      return 'accent';
    },
    addHandlerSpecial() {
      this.$router.push({
        name: this.parentRouteTicket,
        params: { parent: this.customerParent['@id'] }
      });
    },
  }
};
</script>
